import * as React from 'react';
import * as autoBind from 'react-autobind';
import Strings from '../../globals/Strings';
import Themeable from '../../types/Themeable';

export default class LoadRemainingReviewsText extends React.Component<LoadRemainingReviewsTextProps, {}> {
   constructor(props: LoadRemainingReviewsTextProps) {
      super(props);
      autoBind(this);
   }

   render() {
      const {numberOfReviews, totalReviewsCount} = this.props;

      return (
        <div className="load-remaining-reviews">
            <label className="load-remaining-reviews-text-label" htmlFor="load-remaining-reviews-button-id">{Strings.labels.remainingReviewsLabelText.replace('{numberOfReviews}', numberOfReviews.toString()).replace('{totalReviewCount}', totalReviewsCount.toString())}</label>
        </div>
      );
   }
}

export interface LoadRemainingReviewsTextProps extends Themeable {
   totalReviewsCount: number;
   numberOfReviews: number;
}
